import { useCallback, useEffect, useState } from "react";
import { fetchAuditLogs, fetchWebsiteAuditHistory } from "./auditLogApi";
import { message } from "antd";

export function useOviziaAuditLogs() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");
  const [entityType, setEntityType] = useState(""); // "" | "WEBSITE" | "DOMAIN_ORDER"
  const [action, setAction] = useState(""); // "" | one of the AuditAction enum names

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchAuditLogs({ query, entityType, action });
      setEntries(data);
    } finally {
      setLoading(false);
    }
  }, [query, entityType, action]);

  useEffect(() => {
    const handle = setTimeout(load, 250);
    return () => clearTimeout(handle);
  }, [load]);

  return {
    entries,
    loading,
    query,
    setQuery,
    entityType,
    setEntityType,
    action,
    setAction,
    refresh: load,
  };
}


export function useWebsiteAuditHistory(websiteId) {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
 
  const fetchHistory = useCallback(async () => {
    if (!websiteId) return;
    setLoading(true);
    try {
      const data = await fetchWebsiteAuditHistory(websiteId);
      setEntries(data);
    } catch {
      message.error("Failed to load admin activity");
    } finally {
      setLoading(false);
    }
  }, [websiteId]);
 
  return { entries, loading, fetchHistory };
}